import { render, staticRenderFns } from "./MyTournamentsRanking.vue?vue&type=template&id=bcd266ea&"
import script from "./MyTournamentsRanking.vue?vue&type=script&lang=js&"
export * from "./MyTournamentsRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports